module.exports = __webpack_public_path__ + "static/media/greater-than.2d0abc3a.svg";